module.exports = __webpack_public_path__ + "static/media/usageFeeImg.280e3840.svg";